import React, { Fragment } from 'react';
import {
  RichTextFragment,
  TileFragmentFragment,
} from '@/integrations/crystallize/__gql-codegen-types/catalogue/graphql';
import { Bundle } from '@/ui/services/BundleService';
import { RichTextRenderer } from '@/ui/components/tileRenderers/RichTextRenderer';
import { AdditionalInformationBox } from '@/ui/components/shared/additional-information-box/additional-information-box';
import { BundleHostSlot } from '@/ui/components/pages/ProductDetail/types/bundle-host-slot';
import { BundleOption } from './bundle-option/bundle-option';

export interface BundlesSectionProps {
  bundles: Bundle[];
  sectionHeading?: RichTextFragment;
  isSubscription?: boolean;
  openAdditionalInformation?: (tiles?: TileFragmentFragment[], boxId?: string) => void;
  closeAdditionalInformation?: () => void;
  activeBoxId?: string;
  hostSlot?: BundleHostSlot;
}

export function BundlesSection({
  bundles,
  sectionHeading,
  isSubscription,
  openAdditionalInformation,
  closeAdditionalInformation,
  activeBoxId,
  hostSlot,
}: Readonly<BundlesSectionProps>) {
  return (
    <div className="space-y-4 pb-14">
      <RichTextRenderer className=" text-xl" blocks={sectionHeading} />

      {
        bundles?.map((bundle) => (
          <Fragment key={bundle.documentExtRef}>
            <BundleOption bundle={bundle} isSubscription={isSubscription} hostSlot={hostSlot} />
            {bundle.additionalInformation && (
              <AdditionalInformationBox
                additionalInformation={bundle.additionalInformation}
                activeBoxId={activeBoxId}
                onSelect={(boxId) => {
                  openAdditionalInformation?.(
                    bundle.additionalInformation?.additionalInformationTiles,
                    boxId,
                  );
                }}
                onClear={() => {
                  closeAdditionalInformation?.();
                }}
              />
            )}
          </Fragment>
        ))
      }
    </div>
  );
}
